import { Picker, Section, Period, Durations, Timeslots } from './styles'

Picker.Section = Section
Picker.Period = Period
Picker.Durations = Durations
Picker.Timeslots = Timeslots

export default Picker
